import { render } from "./Item3.vue?vue&type=template&id=ed3e7d58"
import script from "./Item3.vue?vue&type=script&lang=ts"
export * from "./Item3.vue?vue&type=script&lang=ts"
script.render = render

export default script